import { Injectable } from '@angular/core'
import { HttpService } from '../http.service'
import { FindMallDto, MallDto, PageResultDto } from '@api/dto'
import { MallPublicDto } from '../../dto/governance-admin/mall-public.dto'

@Injectable({
  providedIn: 'root'
})
export class MallPublicService {
  constructor(private httpService: HttpService) {}

  async find(findMallDto: FindMallDto = {}) {
    return await this.httpService.get<PageResultDto<MallDto>>('/admin/v1/malls', findMallDto)
  }

  async getAllMalls() {
    return await this.httpService.get<PageResultDto<MallPublicDto>>(`/v1/public/malls`);
  }
}
